"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIDGEABLE_REGISTRY_SOURCES = exports.REGISTRY_SOURCES = exports.BANK_FEED_SOURCE_LABELS = exports.IBAN_BEARING_SOURCES = exports.BANK_FEED_SOURCES = void 0;
exports.bankFeedSourceLabel = bankFeedSourceLabel;
exports.isBankFeedSource = isBankFeedSource;
exports.isIbanBearingSource = isIbanBearingSource;
exports.isRegistrySource = isRegistrySource;
exports.isBridgeableRegistrySource = isBridgeableRegistrySource;
exports.BANK_FEED_SOURCES = ['airwallex', 'hsbc-recap', 'db-recap', 'hsbc'];
// Sources whose account identity is a real IBAN. Only these carry a
// match_hash: Airwallex exposes per-currency wallets (no IBAN) and never
// participates in a source swap, so it is deliberately unhashed — enforced
// by a CHECK constraint on bank.bank_transaction.
exports.IBAN_BEARING_SOURCES = [
    'hsbc-recap',
    'db-recap',
    'hsbc',
];
// Human-readable bank name per source — the LAST-RESORT display fallback when
// no per-account name is on record. The authoritative name comes from provider
// evidence (bank_account_balance.bank_name, then
// bank_account_source_registry.bank_name, both fed by re:cap); these labels
// exist so an account with no name anywhere still renders the institution
// instead of a blank. `hsbc-recap` and `hsbc` are the same bank reached two
// ways (re:cap bridge vs the direct middleware), so they share a label.
exports.BANK_FEED_SOURCE_LABELS = {
    airwallex: 'Airwallex',
    'hsbc-recap': 'HSBC',
    'db-recap': 'Deutsche Bank',
    hsbc: 'HSBC',
};
// Null (never a throw) for anything outside the closed source set: this is a
// display fallback, not a validator, and an unrecognised source must degrade to
// "no label" rather than break a page that is otherwise fine.
function bankFeedSourceLabel(source) {
    return isBankFeedSource(source) ? exports.BANK_FEED_SOURCE_LABELS[source] : null;
}
function isBankFeedSource(value) {
    return exports.BANK_FEED_SOURCES.includes(value);
}
function isIbanBearingSource(value) {
    return exports.IBAN_BEARING_SOURCES.includes(value);
}
// The IBAN→source registry's value domain (WP-3): the two bridgeable re:cap
// sources plus three positive facts that are NOT bank-feed sources — the
// Airwallex mirror (skipped: double-count protection), excluded (skipped: a
// human decided this bank does not belong on the matching substrate — e.g.
// Pleo spend cards, owner decision 2026-07-21), and unmapped (unknown BIC;
// transactions on such accounts fail the bridge loudly). Deliberately beside,
// not widening, the closed BANK_FEED_SOURCES set.
exports.REGISTRY_SOURCES = [
    'hsbc-recap',
    'db-recap',
    'airwallex-mirror',
    'excluded',
    'unmapped',
];
exports.BRIDGEABLE_REGISTRY_SOURCES = [
    'hsbc-recap',
    'db-recap',
];
function isRegistrySource(value) {
    return exports.REGISTRY_SOURCES.includes(value);
}
function isBridgeableRegistrySource(value) {
    return exports.BRIDGEABLE_REGISTRY_SOURCES.includes(value);
}
//# sourceMappingURL=sources.js.map